import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();

	const PRIMARY_LIGHT = theme.palette.primary.light;

	const PRIMARY_MAIN = theme.palette.primary.main;

	const PRIMARY_DARK = theme.palette.primary.dark;

	//This Logo is the logo on the CoreApp LEFT navigation bar
	//SVG file view contents is copied below.
	const logo = (
		//Size 40x40 was done to look right
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				version="1.1"
				width="100%"
				height="100%"
				preserveAspectRatio="xMaxYMid meet"
				viewBox="0 0 48 48"
			>
				<defs>
					<linearGradient
						id="#f6f6f6"
						x1="100%"
						x2="50%"
						y1="9.946%"
						y2="50%"
					>
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient
						id="#121212"
						x1="50%"
						x2="50%"
						y1="0%"
						y2="100%"
					>
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient
						id="#111111"
						x1="50%"
						x2="50%"
						y1="0%"
						y2="100%"
					>
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient
						id="#131313"
						x1="50%"
						x2="50%"
						y1="0%"
						y2="100%"
					>
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient
						id="#101010"
						x1="50%"
						x2="50%"
						y1="0%"
						y2="100%"
					>
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient
						id="#090909"
						x1="50%"
						x2="50%"
						y1="0%"
						y2="100%"
					>
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g>
					<path
						fill="#f6f6f6"
						d="M -0.5,-0.5 C 15.5,-0.5 31.5,-0.5 47.5,-0.5C 47.5,15.5 47.5,31.5 47.5,47.5C 31.5,47.5 15.5,47.5 -0.5,47.5C -0.5,31.5 -0.5,15.5 -0.5,-0.5 Z"
					/>
				</g>
				<g>
					<path
						fill="#121212"
						d="M 13.5,0.5 C 21.2086,2.39303 23.2086,6.89303 19.5,14C 13.7945,14.6381 10.7945,11.9715 10.5,6C 10.8627,3.80771 11.8627,1.97438 13.5,0.5 Z"
					/>
				</g>
				<g>
					<path
						fill="#111111"
						d="M 29.5,0.5 C 33.5803,0.0806938 35.5803,1.91403 35.5,6C 35.4151,12.7738 32.2484,15.2738 26,13.5C 25.1251,12.1268 24.6251,10.6268 24.5,9C 25.1366,5.53687 26.8033,2.70353 29.5,0.5 Z"
					/>
				</g>
				<g>
					<path
						fill="#131313"
						d="M 3.5,11.5 C 11.0446,13.0875 13.0446,17.2541 9.5,24C 5.83394,25.271 3.33394,24.1044 2,20.5C 1.06799,17.1769 1.56799,14.1769 3.5,11.5 Z"
					/>
				</g>
				<g>
					<path
						fill="#101010"
						d="M 38.5,11.5 C 42.3382,11.0072 44.3382,12.6738 44.5,16.5C 43.9894,22.8573 40.8227,24.8573 35,22.5C 33.6624,17.9597 34.8291,14.293 38.5,11.5 Z"
					/>
				</g>
				<g>
					<path
						fill="#090909"
						d="M 19.5,15.5 C 22.3198,15.2475 24.9865,15.7475 27.5,17C 30.6311,21.1328 34.1311,24.9662 38,28.5C 39.9136,35.3679 37.4136,39.0346 30.5,39.5C 25.3362,38.2135 20.1695,38.2135 15,39.5C 8.46314,38.7955 6.1298,35.1288 8,28.5C 12.3307,24.4291 16.164,20.0958 19.5,15.5 Z"
					/>
				</g>
			</svg>
		</Box>
	);

	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="/">{logo}</RouterLink>;
}
